<template>
  <div>
    <v-row>
      <v-col>
        <!-- <v-carousel v-model="photoIndex">
          <v-carousel-item
            v-for="(item,i) in items"
            :key="i"
            :src="item.src"
          >
          </v-carousel-item>
        </v-carousel> -->
        <carousel
          :perPage="1"
          :perPageCustom="[[1264, 2]]"
        >
          <slide v-for="(item,i) in items" :key="i">
            <v-img
              :aspect-ratio="16/9"
              :src="item.src"
            ></v-img>
          </slide>
        </carousel>
      </v-col>
    </v-row>
    <v-row id="order">
      <v-col>
        <v-row>
          <v-col class="order text-center">
            <span>快速報價</span>
          </v-col>
        </v-row>
        <v-row
        justify="center"
        >
          <v-col lg="6" cols="12">
            <div class="home-office-container text-center home-moving-box" @click="to('home.html')">
              <div class="home-moving-container" >
                <span>家居搬運</span>
                <div >
                  <v-icon class="home-moving-icon">
                    mdi-home
                  </v-icon>
                </div>
              </div>
            </div>
          </v-col>
          <!-- <v-spacer v-if="!isMobile"></v-spacer> -->
          <v-col lg="6" cols="12">
            <div class="home-office-container text-center office-moving-box" @click="to('office.html')">
              <div class="home-moving-container" >
                <span>辦公室搬運</span>
                <div >
                  <v-icon class="office-moving-icon main-color">
                    mdi-office-building
                  </v-icon>
                </div>
              </div>
            </div>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <div v-if="!isMobile" class="mt-10 pb-10"></div>
    <v-row >
      <v-col>
        <div class="moving-desc-container text-center">
          <div class="moving-desc mt-80 mb-10 px-10" >
            <span class="">我們細心周到，取價合理，紀律嚴明， 務求保證各搬運物件之安全。設有免費 網上報價及免費上門報價。
            </span>
            <v-row
              class="mt-80"
              justify="center"
            >
              <v-col xl="3" lg="3" cols="6">
                <div class="moving-desc-title">20年+</div>
                <div >經驗</div>
              </v-col>
              <v-col xl="3" lg="3" cols="6">
                <div class="moving-desc-title">3萬+</div>
                <div >成功案例</div>
              </v-col>
              <v-col xl="3" lg="3" cols="6">
                <div class="moving-desc-title">1站式</div>
                <div >服務</div>
              </v-col>
            </v-row>
          </div>
        </div>
      </v-col>
    </v-row>
    <v-row id="scope">
      <v-col>
        <div class="scope-desc-container text-center">
          <div class="scope-desc px-5 mt-80 main-color">
            誠意為大小商戶及各類型住宅， 包括村屋、唐樓、寫字樓及大型屋苑<br/>提供搬運及存倉等服務。
          </div>
          <v-row class="mt-80"  justify="center">
            <v-col xl="3" lg="6" md="6" cols="12">
              <v-card
                class="mx-auto scope-card rounded-xl text-center"
                width="415"
                elevation="20"
                outlined
                @mouseover="scope1 = false" @mouseleave="scope1 = true"
              >
              <div v-show="scope1" class="scope-card-content main-color mt-80">
                <span>家居及辦公室搬運</span>
                <div >
                  <img src="@/assets/svg/scope_icon_1.svg">
                </div>
              </div>
              <div v-show="!scope1"  class="scope-card-content-hover main-color mt-80 px-5" >
                <span>家居搬運：專業搬屋員在搬運前細心妥善包裝所有傢俬、電器確保物品得到最佳保護，並能安全運抵目的地，如客人要專業搬屋員亦會為閣下已拆的傢俬裝好。
                  <br/><br/>
                  寫字樓搬運：搬寫宇樓與搬屋最大的不同是那些一個個的大文件櫃，要把文件先入箱然後再把文件櫃包裹，而且，文件櫃往往十分重，需要有專業訓練才可讓文件櫃受保護而平安到達。
                </span>
              </div>
              </v-card>
            </v-col>
            <v-col xl="3" lg="6" md="6" cols="12">
              <v-card
                class="mx-auto scope-card rounded-xl text-center"
                width="415"
                elevation="20"
                outlined
                @mouseover="scope2 = false" @mouseleave="scope2 = true"
              >
              <div v-show="scope2" class="scope-card-content main-color mt-80">
                <span>村屋吊運服務</span>
                <div >
                  <img src="@/assets/svg/scope_icon_2.svg">
                </div>
              </div>
              <div v-show="!scope2"  class="scope-card-content-hover main-color mt-80 px-5" >
                <span>
                  村屋的設計多因應不同地勢而建，村屋搬遷時，樓梯的闊窄直接影響搬遷是否 順利。
                  <br/><br/>
                  本公司設有大型吊車及專業搬運村屋的 經驗, 為顧客安全吊起大型及重型的傢 俬或電器。
                </span>
              </div>
              </v-card>
            </v-col>
            <v-col xl="3" lg="6" md="6" cols="12">
              <v-card
                class="mx-auto scope-card rounded-xl text-center"
                width="415"
                elevation="20"
                outlined
                @mouseover="scope3 = false" @mouseleave="scope3 = true"
              >
                <div v-show="scope3" class="scope-card-content main-color mt-80">
                  <span>存倉服務</span>
                  <div >
                    <img src="@/assets/svg/scope_icon_3.svg">
                  </div>
                </div>
                <div v-show="!scope3"  class="scope-card-content-hover main-color mt-80 px-5" >
                  <span>
                    本公司設有大型吊車及專業搬運村屋的 經驗, 為顧客安全吊起大型及重型的傢 俬或電器。
                    我們的貨倉位於保安嚴格的工廠大廈內 ，加上收費合理，長期及短期存倉均一 律歡迎。
                    <br/><br/>
                    所有傢俬及雜物在運往貨倉前定會編上 號碼，並填上傢俬種類 及客戶名稱，確 保以最有系統的方式處理。
                  </span>
                </div>
              </v-card>
            </v-col>
          </v-row>
        </div>
      </v-col>
    </v-row>
    <v-row class="mt-80" id="about">
      <v-col xl="7" cols="12" class="about-container">
        <img src="@/assets/photo/about_bg_up.png" :class="imageWidthClass">
        <div :class="aboutDescClass">
          特別的搬運工程，<br/>包括吊運、船運及搬琴等，一概歡迎。<br/><br/>
          我們細心周到，取價合理，紀律嚴明， 務求保證各搬運物件之安全。設有免費 網上報價及免費上門報價。
        </div>
        <img v-if="!isMobile" class="about-bg-bottom" src="@/assets/photo/about_bg_bottom.png">
      </v-col>
      <v-col xl="5" cols="12" class="pt-5">
        <iframe class="mt-10" width="100%" height="480" src="https://www.youtube.com/embed/VV7IxjPVx5U">
        </iframe>
      </v-col>
    </v-row>
    <v-row class="mt-10 pb-10" id="contact">
      <v-col>
        <div class="text-center">
          <img :class="footerLogo" src="@/assets/logo.png">
        </div>
        <v-row
        class="mt-80"
        justify="center">
          <v-col md="3" cols="12" class="text-center">
            <div >
              <img src="@/assets/svg/contact_1.svg">
            </div>
            <div class="main-color contact-desc">2797 3626 / 6418 4666<br/>李生 Ben Li</div>
          </v-col>
          <v-col md="3" cols="12" class="text-center">
            <div >
              <img src="@/assets/svg/contact_2.svg">
            </div>
            <div class="main-color contact-desc">沙田火炭環球工業大廈<br/>World Wide Ind Ctr, Fo Tan, Sha Tin.</div>
          </v-col>
          <v-col md="3" cols="12" class="text-center">
            <div >
              <img src="@/assets/svg/contact_3.svg">
            </div>
            <div class="main-color contact-desc">champion_benli@yahoo.com.hk</div>
          </v-col>
        </v-row>
        <div class="main-color text-center contact-desc mt-10 pb-10">
          © 2011 Champion Moving Co., Ltd All rights reserved.
        </div>
      </v-col>
    </v-row>
    <BackToTop target=""></BackToTop>
    <WhatsappBtn
      whatsappNumber="85264184666"
    ></WhatsappBtn>
  </div>
</template>

<script>
import { Carousel, Slide } from 'vue-carousel'
import common from '@/components/mixin/common'
import BackToTop from '@/components/BackToTop'
import WhatsappBtn from '@/components/WhatsappBtn'
export default {
  name: 'index',
  mixins: [common],
  components: {
    BackToTop,
    WhatsappBtn,
    Carousel,
    Slide
  },
  data () {
    return {
      cssProps: {
        // backgroundImage: `url(${require('@/assets/photo/about_bg.png')})`,
        // backgroundSize: 'contain',
        height: '500px'
      },
      photoIndex: 0,
      scope1: true,
      scope2: true,
      scope3: true,
      // colors: [
      //   'primary',
      //   'secondary',
      //   'yellow darken-2',
      //   'red',
      //   'orange'
      // ]
      items: [
        {
          src: require('@/assets/photo/np1.png')
        },
        {
          src: require('@/assets/photo/np2.png')
        },
        {
          src: require('@/assets/photo/np3.png')
        },
        {
          src: require('@/assets/photo/np4.png')
        }
      ]
    }
  },
  computed: {
    footerLogo () {
      if (this.isMobile) {
        return 'footer-logo'
      }
      return ''
    },
    imageWidthClass () {
      if (this.isMobile) {
        return 'vw-100'
      }
      return ''
    },
    aboutDescClass () {
      if (this.isMobile) {
        return 'about-desc px-5 main-color'
      }
      return 'about-desc px-5 about-desc-desktop main-color'
    }
  },
  methods: {
    handleHover (target) {
      this[target] = false
    },
    to (target) {
      const routeData = this.$router.resolve({ path: target })
      window.open(routeData.href, '_blank')
    },
    toHash () {
      // console.log('this.$router',this.$router)
      if (this.$router.history.current.query.to) {
        this.$nextTick(() => window.document.querySelector('#' + this.$router.history.current.query.to).scrollIntoView())
      }
    }
  },
  watch: {
    '$route.params.to' (val) {
      // call the method which loads your initial state
      this.toHash()
    }
  },
  mounted () {
    this.toHash()
    console.log('this.$vuetify.breakpoint.mobile', this.$vuetify.breakpoint.mobile)
    console.log('this.isMobile', this.isMobile)
  }

}
</script>

<style>
  .footer-logo{
    width:100%;
    max-width: 90%;
  }
  .vw-100{
    width:100vw;
  }
  .order {
    width: 241px;
    white-space: nowrap;
    text-align: left;
    font-family: Source Han Sans HK;
    font-style: normal;
    font-weight: bold;
    /* font-size: 60px; */
    font-size: 4rem;
    color: rgba(54, 77, 137, 1);
  }
  .about-bg-bottom{
    position: relative;
    top:-110px;
  }
  /* .about-container{
    height: 800px;
  } */
  .contact-desc{
    font-family: Source Han Sans HK;
    font-style: normal;
    font-weight: normal;
    font-size: 20px;
  }
  .main-color{
    color: rgba(54, 77, 137, 1) !important;
  }
  .scope-card{
    max-width: 100vw;
    height:500px;
    display: table;
    text-align: center;
  }
  .moving-desc-title{
    color: rgba(235, 242, 51, 1) !important;
    font-size: 4rem !important;
  }
  .mt-80{
    margin-top: 80px !important;
  }
  .home-moving-icon {
    color: rgba(235, 242, 51, 1) !important;
    font-size: 9rem !important;
  }
  .office-moving-icon {
    color: rgba(54, 77, 137, 1) !important;
    font-size: 9rem !important;
  }
  .home-moving-box{
    background-color: rgba(54, 77, 137, 1);
    cursor: pointer;
  }
  .office-moving-box{
    background-color: rgba(235, 242, 51, 1);
    cursor: pointer;
  }
  .home-office-container{
    display: table;
    text-align: center;
    width:100%;
    height:400px;
  }
  .moving-desc-container{
    height:486px;
    width:100%;
    display: table;
    text-align: center;
    background-color: rgba(54, 77, 137, 1);
  }

  .scope-desc-container{
    height:486px;
    width:100%;
    display: table;
    text-align: center;
  }
  .moving-desc{
    font-family: Source Han Sans HK;
    font-style: normal;
    font-size: 3rem;
    color: rgba(255, 255, 255, 1);
  }

  .scope-desc{
    font-family: Source Han Sans HK;
    font-style: normal;
    font-size: 3rem;
    /* color: rgba(54, 77, 137, 1); */
  }

  .home-moving-container {
    display: table-cell;
    vertical-align: middle;
    font-family: Source Han Sans HK;
    font-style: normal;
    font-weight: bold;
    font-size: 3rem;
    color: rgba(255, 255, 255, 1);
  }
  .scope-card-content {
    display: table-cell;
    vertical-align: middle;
    font-family: Source Han Sans HK;
    font-style: normal;
    font-size: 2rem;
    /* color: rgba(54, 77, 137, 1); */
  }
  .scope-card-content-hover{
    text-align: left;
    display: table-cell;
    vertical-align: middle;
    font-family: Source Han Sans HK;
    font-style: normal;
    font-size: 1.5rem;
  }
  .about-desc{
    text-align: left;
    font-family: Source Han Sans HK;
    font-style: normal;
    font-weight: normal;
    font-size: 2rem;
  }
  .about-desc-desktop{
    position: relative;
    margin-left: 300px !important;
  }
</style>

<!-- <style scoped>
  .mediaViewInfo {
    --web-view-name: Web 1920 – 1;
    --web-view-id: Web_1920__1;
    --web-scale-on-resize: true;
    --web-enable-deep-linking: true;
  }

  :root {
    --web-view-ids: Web_1920__1;
  }

  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
    border: none;
  }

  #Web_1920__1 {
    position: absolute;
    width: 1920px;
    height: 4051px;
    background-color: rgba(255, 255, 255, 1);
    overflow: hidden;
    --web-view-name: Web 1920 – 1;
    --web-view-id: Web_1920__1;
    --web-scale-on-resize: true;
    --web-enable-deep-linking: true;
  }

  #Path_306_ {
    fill: url(#Path_306_);
  }

  .Path_306_ {
    overflow: visible;
    position: absolute;
    width: 1920px;
    height: 477px;
    left: 0px;
    top: 180px;
    transform: matrix(1, 0, 0, 1, 0, 0);
  }

  #Component_2__3 {
    position: absolute;
    width: 415px;
    height: 500px;
    left: 1268px;
    top: 2213px;
    overflow: visible;
  }

  #Group_40 {
    position: absolute;
    width: 415px;
    height: 500px;
    left: 0px;
    top: 0px;
    overflow: visible;
  }

  #Rectangle_12 {
    fill: rgba(255, 255, 255, 1);
  }

  .Rectangle_12 {
    filter: drop-shadow(0px 30px 40px rgba(0, 0, 0, 0.161));
    position: absolute;
    overflow: visible;
    width: 535px;
    height: 620px;
    left: 0px;
    top: 0px;
  }

  #Group_152 {
    position: absolute;
    width: 159.933px;
    height: 172.507px;
    left: 127.033px;
    top: 200.303px;
    overflow: visible;
  }

  #Group_153 {
    position: absolute;
    width: 153.016px;
    height: 164.525px;
    left: 2.82px;
    top: 3.802px;
    overflow: visible;
  }

  #Path_173 {
    fill: rgba(54, 77, 137, 1);
  }

  .Path_173 {
    overflow: visible;
    position: absolute;
    width: 149.978px;
    height: 100.326px;
    left: 2.218px;
    top: 0px;
    transform: matrix(1, 0, 0, 1, 0, 0);
  }

  #Path_174 {
    fill: rgba(54, 77, 137, 1);
  }

  .Path_174 {
    overflow: visible;
    position: absolute;
    width: 67.089px;
    height: 103.245px;
    left: 0px;
    top: 59.683px;
    transform: matrix(1, 0, 0, 1, 0, 0);
  }

  #Path_175 {
    fill: rgba(54, 77, 137, 1);
  }

  .Path_175 {
    overflow: visible;
    position: absolute;
    width: 82.535px;
    height: 116.756px;
    left: 70.482px;
    top: 47.77px;
    transform: matrix(1, 0, 0, 1, 0, 0);
  }

  #ID4804552381535029667 {
    position: absolute;
    width: 159.933px;
    height: 172.507px;
    left: 0px;
    top: 0px;
    overflow: visible;
  }

  #Path_170 {
    fill: rgba(255, 255, 255, 1);
  }

  .Path_170 {
    overflow: visible;
    position: absolute;
    width: 159.933px;
    height: 172.507px;
    left: 0px;
    top: 0px;
    transform: matrix(1, 0, 0, 1, 0, 0);
  }

  #Path_171 {
    fill: rgba(255, 255, 255, 1);
  }

  .Path_171 {
    overflow: visible;
    position: absolute;
    width: 38.292px;
    height: 27.392px;
    left: 28.357px;
    top: 93.868px;
    transform: matrix(1, 0, 0, 1, 0, 0);
  }

  #Path_172 {
    fill: rgba(255, 255, 255, 1);
  }

  .Path_172 {
    overflow: visible;
    position: absolute;
    width: 24.361px;
    height: 18.119px;
    left: 42.289px;
    top: 117.985px;
    transform: matrix(1, 0, 0, 1, 0, 0);
  }

  #storing {
    left: 137px;
    top: 80px;
    position: absolute;
    overflow: visible;
    width: 141px;
    white-space: nowrap;
    text-align: left;
    font-family: Source Han Sans HK;
    font-style: normal;
    font-weight: normal;
    font-size: 35px;
    color: rgba(54, 77, 137, 1);
  }

  #Component_2__2 {
    position: absolute;
    width: 415px;
    height: 500px;
    left: 753px;
    top: 2213px;
    overflow: visible;
  }

  #Group_39 {
    position: absolute;
    width: 415px;
    height: 500px;
    left: 0px;
    top: 0px;
    overflow: visible;
  }

  #Path_181 {
    fill: rgba(255, 255, 255, 1);
  }

  .Path_181 {
    filter: drop-shadow(0px 30px 40px rgba(0, 0, 0, 0.161));
    overflow: visible;
    position: absolute;
    width: 535px;
    height: 620px;
    left: 0px;
    top: 0px;
    transform: matrix(1, 0, 0, 1, 0, 0);
  }

  #_bj {
    left: 102px;
    top: 80px;
    position: absolute;
    overflow: visible;
    width: 211px;
    white-space: nowrap;
    text-align: left;
    font-family: Source Han Sans HK;
    font-style: normal;
    font-weight: normal;
    font-size: 35px;
    color: rgba(54, 77, 137, 1);
  }

  #Group_151 {
    position: absolute;
    width: 81.849px;
    height: 140.187px;
    left: 166.075px;
    top: 224.5px;
    overflow: visible;
  }

  #Group_150 {
    position: absolute;
    width: 81.849px;
    height: 140.187px;
    left: 0px;
    top: 0px;
    overflow: visible;
  }

  #Path_176 {
    fill: rgba(54, 77, 137, 1);
  }

  .Path_176 {
    overflow: visible;
    position: absolute;
    width: 4.834px;
    height: 61.126px;
    left: 0.01px;
    top: 0px;
    transform: matrix(1, 0, 0, 1, 0, 0);
  }

  #Path_177 {
    fill: rgba(54, 77, 137, 1);
  }

  .Path_177 {
    overflow: visible;
    position: absolute;
    width: 4.834px;
    height: 61.126px;
    left: 76.871px;
    top: 0px;
    transform: matrix(1, 0, 0, 1, 0, 0);
  }

  #Path_178 {
    fill: rgba(54, 77, 137, 1);
  }

  .Path_178 {
    overflow: visible;
    position: absolute;
    width: 34.66px;
    height: 50.612px;
    left: 23.455px;
    top: 89.575px;
    transform: matrix(1, 0, 0, 1, 0, 0);
  }

  #Path_179 {
    fill: rgba(54, 77, 137, 1);
  }

  .Path_179 {
    overflow: visible;
    position: absolute;
    width: 81.849px;
    height: 71.447px;
    left: 0px;
    top: 22.962px;
    transform: matrix(1, 0, 0, 1, 0, 0);
  }

  #Path_180 {
    fill: rgba(255, 255, 255, 1);
  }

  .Path_180 {
    overflow: visible;
    position: absolute;
    width: 46.426px;
    height: 40.872px;
    left: 17.644px;
    top: 38.261px;
    transform: matrix(1, 0, 0, 1, 0, 0);
  }

  #Rectangle_5 {
    fill: rgba(54, 77, 137, 1);
  }

  .Rectangle_5 {
    position: absolute;
    overflow: visible;
    width: 1920px;
    height: 486px;
    left: 0px;
    top: 1400px;
  }

  #____dk {
    left: 356px;
    top: 1484px;
    position: absolute;
    overflow: visible;
    width: 1210px;
    white-space: nowrap;
    text-align: center;
    font-family: Source Han Sans HK;
    font-style: normal;
    font-weight: normal;
    font-size: 40px;
    color: rgba(255, 255, 255, 1);
  }

  #ID20__dl {
    left: 361px;
    top: 1658px;
    position: absolute;
    overflow: visible;
    width: 171px;
    white-space: nowrap;
    text-align: center;
    font-family: Source Han Sans HK;
    font-style: normal;
    font-weight: normal;
    font-size: 60px;
    color: rgba(235, 242, 51, 1);
  }

  #ID1__dm {
    left: 880px;
    top: 1658px;
    position: absolute;
    overflow: visible;
    width: 161px;
    white-space: nowrap;
    text-align: center;
    font-family: Source Han Sans HK;
    font-style: normal;
    font-weight: normal;
    font-size: 60px;
    color: rgba(235, 242, 51, 1);
  }

  #ID1__dn {
    left: 1415px;
    top: 1658px;
    position: absolute;
    overflow: visible;
    width: 157px;
    white-space: nowrap;
    text-align: center;
    font-family: Source Han Sans HK;
    font-style: normal;
    font-weight: normal;
    font-size: 60px;
    color: rgba(235, 242, 51, 1);
  }

  #Component_10__1 {
    width: 691px;
    height: 400px;
  }

  #Group_3 {
    width: 691px;
    height: 400px;
  }

  #Rectangle_3 {
    fill: rgba(54, 77, 137, 1);
  }

  .Rectangle_3 {
    width: 691px;
    height: 400px;
  }

  #Icons {
    width: 165.709px;
    height: 165.709px;
  }

  #Rounded {
    width: 165.709px;
    height: 165.709px;
  }

  #Action {
    position: absolute;
    width: 165.709px;
    height: 165.709px;
    left: 0px;
    top: 0px;
    overflow: visible;
  }

  #-Round--Action--home {
    position: absolute;
    width: 165.709px;
    height: 165.709px;
    left: 0px;
    top: 0px;
    overflow: visible;
  }

  #Group_33 {
    position: absolute;
    width: 165.709px;
    height: 165.709px;
    left: 0px;
    top: 0px;
    overflow: visible;
  }

  #Path {
    fill: transparent;
  }

  .Path {
    overflow: visible;
    width: 165.709px;
    height: 165.709px;
    transform: matrix(1, 0, 0, 1, 0, 0);
  }

  #Icon-Color {
    fill: rgba(235, 242, 51, 1);
  }

  .Icon-Color {
    overflow: visible;
    position: absolute;
    width: 127.045px;
    height: 114.995px;
    left: 19.348px;
    top: 23.096px;
    transform: matrix(1, 0, 0, 1, 0, 0);
  }

  #Component_11__1 {
    position: absolute;
    width: 691px;
    height: 400px;
    left: 1083px;
    top: 876px;
    overflow: visible;
  }

  #Group_2 {
    position: absolute;
    width: 691px;
    height: 400px;
    left: 0px;
    top: 0px;
    overflow: visible;
  }

  #Rectangle_6 {
    fill: rgba(235, 242, 51, 1);
  }

  .Rectangle_6 {
    position: absolute;
    overflow: visible;
    width: 691px;
    height: 400px;
    left: 0px;
    top: 0px;
  }

  #_cc {
    left: 221px;
    top: 81px;
    position: absolute;
    overflow: visible;
    width: 251px;
    white-space: nowrap;
    text-align: left;
    font-family: Source Han Sans HK;
    font-style: normal;
    font-weight: bold;
    font-size: 50px;
    color: rgba(255, 255, 255, 1);
  }

  #ID1435580591547464161 {
    fill: rgba(54, 77, 137, 1);
  }

  .ID1435580591547464161 {
    overflow: visible;
    position: absolute;
    width: 127.294px;
    height: 145.479px;
    left: 281.853px;
    top: 177.291px;
    transform: matrix(1, 0, 0, 1, 0, 0);
  }

  #Component_2__1 {
    position: absolute;
    width: 415px;
    height: 500px;
    left: 238px;
    top: 2213px;
    overflow: visible;
  }

  #Rectangle_12_cf {
    fill: rgba(255, 255, 255, 1);
  }

  .Rectangle_12_cf {
    filter: drop-shadow(0px 30px 40px rgba(0, 0, 0, 0.161));
    position: absolute;
    overflow: visible;
    width: 535px;
    height: 620px;
    left: 0px;
    top: 0px;
  }

  #_cg {
    left: 67px;
    top: 82px;
    position: absolute;
    overflow: visible;
    width: 281px;
    white-space: nowrap;
    text-align: left;
    font-family: Source Han Sans HK;
    font-style: normal;
    font-weight: normal;
    font-size: 35px;
    color: rgba(54, 77, 137, 1);
  }

  #maps_home_work_black_24dp {
    position: absolute;
    width: 194.183px;
    height: 194.183px;
    left: 109.908px;
    top: 189.465px;
    overflow: visible;
  }

  #Group_35 {
    position: absolute;
    width: 194.183px;
    height: 194.183px;
    left: 0px;
    top: 0px;
    overflow: visible;
  }

  #Path_167 {
    fill: transparent;
  }

  .Path_167 {
    overflow: visible;
    position: absolute;
    width: 194.183px;
    height: 194.183px;
    left: 0px;
    top: 0px;
    transform: matrix(1, 0, 0, 1, 0, 0);
  }

  #Group_37 {
    position: absolute;
    width: 178.001px;
    height: 145.638px;
    left: 8.091px;
    top: 24.273px;
    overflow: visible;
  }

  #Group_36 {
    position: absolute;
    width: 178.001px;
    height: 145.638px;
    left: 0px;
    top: 0px;
    overflow: visible;
  }

  #Path_168 {
    fill: rgba(54, 77, 137, 1);
  }

  .Path_168 {
    overflow: visible;
    position: absolute;
    width: 113.274px;
    height: 121.365px;
    left: 0px;
    top: 24.273px;
    transform: matrix(1, 0, 0, 1, 0, 0);
  }

  #Path_169 {
    fill: rgba(54, 77, 137, 1);
  }

  .Path_169 {
    overflow: visible;
    position: absolute;
    width: 105.183px;
    height: 145.637px;
    left: 72.819px;
    top: 0px;
    transform: matrix(1, 0, 0, 1, 0, 0);
  }

  #Rectangle_7 {
    fill: rgba(255, 255, 255, 1);
  }

  .Rectangle_7 {
    position: absolute;
    overflow: visible;
    width: 1920px;
    height: 481px;
    left: 0px;
    top: 0px;
  }

  #index_01_02_02 {
    position: absolute;
    width: 400px;
    height: 84px;
    left: 760px;
    top: 54px;
    overflow: visible;
  }

  #_2011_Champion_Moving_Co_Ltd_A {
    left: 732px;
    top: 385px;
    position: absolute;
    overflow: visible;
    width: 492px;
    white-space: nowrap;
    text-align: left;
    font-family: Source Han Sans HK;
    font-style: normal;
    font-weight: normal;
    font-size: 20px;
    color: rgba(54, 77, 137, 1);
  }

  #Page-1 {
    position: absolute;
    width: 56px;
    height: 56.004px;
    left: 418px;
    top: 215.465px;
    overflow: visible;
  }

  #Dribbble-Light-Preview {
    position: absolute;
    width: 56px;
    height: 56.004px;
    left: 0px;
    top: 0px;
    overflow: visible;
  }

  #icons {
    position: absolute;
    width: 56px;
    height: 56.004px;
    left: 0px;
    top: 0px;
    overflow: visible;
  }

  #call-192 {
    fill: rgba(54, 77, 137, 1);
  }

  .call-192 {
    overflow: visible;
    position: absolute;
    width: 56px;
    height: 56.004px;
    left: 0px;
    top: 0px;
    transform: matrix(1, 0, 0, 1, 0, 0);
  }

  #Icons_cw {
    position: absolute;
    width: 74.708px;
    height: 74.708px;
    left: 1438.646px;
    top: 211.777px;
    overflow: visible;
  }

  #Rounded_cx {
    position: absolute;
    width: 74.708px;
    height: 74.708px;
    left: 0px;
    top: 0px;
    overflow: visible;
  }

  #Communication {
    position: absolute;
    width: 74.708px;
    height: 74.708px;
    left: 0px;
    top: 0px;
    overflow: visible;
  }

  #-Round--Communication--email {
    position: absolute;
    width: 74.708px;
    height: 74.708px;
    left: 0px;
    top: 0px;
    overflow: visible;
  }

  #Group_32 {
    position: absolute;
    width: 74.708px;
    height: 74.708px;
    left: 0px;
    top: 0px;
    overflow: visible;
  }

  #Path_c {
    fill: transparent;
  }

  .Path_c {
    overflow: visible;
    position: absolute;
    width: 74.708px;
    height: 74.708px;
    left: 0px;
    top: 0px;
    transform: matrix(1, 0, 0, 1, 0, 0);
  }

  #Icon-Color_c {
    fill: rgba(54, 77, 137, 1);
  }

  .Icon-Color_c {
    overflow: visible;
    position: absolute;
    width: 62.257px;
    height: 49.805px;
    left: 6.226px;
    top: 12.451px;
    transform: matrix(1, 0, 0, 1, 0, 0);
  }

  #ID2797_3626__6418_4666 {
    left: 344px;
    top: 286px;
    position: absolute;
    overflow: visible;
    width: 205px;
    white-space: nowrap;
    text-align: center;
    font-family: Source Han Sans HK;
    font-style: normal;
    font-weight: normal;
    font-size: 20px;
    color: rgba(54, 77, 137, 1);
  }

  #champion_benliyahoocomhk {
    left: 1324px;
    top: 286px;
    position: absolute;
    overflow: visible;
    width: 305px;
    white-space: nowrap;
    text-align: center;
    font-family: Source Han Sans HK;
    font-style: normal;
    font-weight: normal;
    font-size: 20px;
    color: rgba(54, 77, 137, 1);
  }

  #_World_Wide_Ind_Ctr_Fo_Tan_Sha {
    left: 796px;
    top: 286px;
    position: absolute;
    overflow: visible;
    width: 329px;
    white-space: nowrap;
    text-align: center;
    font-family: Source Han Sans HK;
    font-style: normal;
    font-weight: normal;
    font-size: 20px;
    color: rgba(54, 77, 137, 1);
  }

  #Icon_material-location-on {
    fill: rgba(54, 77, 137, 1);
  }

  .Icon_material-location-on {
    overflow: visible;
    position: absolute;
    width: 40.064px;
    height: 57.234px;
    left: 943.014px;
    top: 211.883px;
    transform: matrix(1, 0, 0, 1, 0, 0);
  }

  #ID20211205_123404 {
    position: absolute;
    width: 733px;
    height: 473px;
    left: 1049px;
    top: 2899px;
    overflow: visible;
  }

  #Scroll_Group_1 {
    mix-blend-mode: normal;
    position: absolute;
    width: 1644px;
    height: 477px;
    left: 138px;
    top: 180px;
    overflow: hidden;
  }

  #Mask_Group_1 {
    position: absolute;
    width: 754px;
    height: 477px;
    left: 0px;
    top: 0px;
    overflow: visible;
  }

  #Mask_Group_2 {
    position: absolute;
    width: 493px;
    height: 477px;
    left: 774px;
    top: 0px;
    overflow: visible;
  }

  #Mask_Group_3 {
    position: absolute;
    width: 567px;
    height: 477px;
    left: 1287px;
    top: 0px;
    overflow: visible;
  }

  #Mask_Group_4 {
    position: absolute;
    width: 524px;
    height: 477px;
    left: 1874px;
    top: 0px;
    overflow: visible;
  }

  #arrow_back_ios_black_24dp {
    position: absolute;
    width: 60px;
    height: 60px;
    left: 50px;
    top: 388px;
    overflow: visible;
  }

  #Path_304 {
    fill: transparent;
  }

  .Path_304 {
    overflow: visible;
    position: absolute;
    width: 60px;
    height: 60px;
    left: 0px;
    top: 0px;
    transform: matrix(1, 0, 0, 1, 0, 0);
  }

  #Path_305 {
    fill: rgba(255, 255, 255, 1);
  }

  .Path_305 {
    overflow: visible;
    position: absolute;
    width: 30.658px;
    height: 49.27px;
    left: 12.226px;
    top: 5.365px;
    transform: matrix(1, 0, 0, 1, 0, 0);
  }

  #arrow_back_ios_black_24dp_dg {
    position: absolute;
    width: 60px;
    height: 60px;
    left: 1810px;
    top: 388.5px;
    overflow: visible;
  }

  #Path_304_dh {
    fill: transparent;
  }

  .Path_304_dh {
    overflow: visible;
    position: absolute;
    width: 60px;
    height: 60px;
    left: 0px;
    top: 0px;
    transform: matrix(1, 0, 0, 1, 0, 0);
  }

  #Path_305_di {
    fill: rgba(255, 255, 255, 1);
  }

  .Path_305_di {
    overflow: visible;
    position: absolute;
    width: 30.658px;
    height: 49.27px;
    left: 17.116px;
    top: 5.365px;
    transform: matrix(1, 0, 0, 1, 0, 0);
  }

  #Rectangle_79 {
    fill: rgba(54, 77, 137, 1);
  }

  .Rectangle_79 {
    position: absolute;
    overflow: visible;
    width: 1920px;
    height: 486px;
    left: 0px;
    top: 1400px;
  }

  #____dk {
    left: 356px;
    top: 1484px;
    position: absolute;
    overflow: visible;
    width: 1210px;
    white-space: nowrap;
    text-align: center;
    font-family: Source Han Sans HK;
    font-style: normal;
    font-weight: normal;
    font-size: 40px;
    color: rgba(255, 255, 255, 1);
  }

  #ID20__dl {
    left: 361px;
    top: 1658px;
    position: absolute;
    overflow: visible;
    width: 171px;
    white-space: nowrap;
    text-align: center;
    font-family: Source Han Sans HK;
    font-style: normal;
    font-weight: normal;
    font-size: 60px;
    color: rgba(235, 242, 51, 1);
  }

  #ID1__dm {
    left: 880px;
    top: 1658px;
    position: absolute;
    overflow: visible;
    width: 161px;
    white-space: nowrap;
    text-align: center;
    font-family: Source Han Sans HK;
    font-style: normal;
    font-weight: normal;
    font-size: 60px;
    color: rgba(235, 242, 51, 1);
  }

  #ID1__dn {
    left: 1415px;
    top: 1658px;
    position: absolute;
    overflow: visible;
    width: 157px;
    white-space: nowrap;
    text-align: center;
    font-family: Source Han Sans HK;
    font-style: normal;
    font-weight: normal;
    font-size: 60px;
    color: rgba(235, 242, 51, 1);
  }

  #Line_6 {
    fill: transparent;
    stroke: rgba(54, 77, 137, 1);
    stroke-width: 10px;
    stroke-linejoin: miter;
    stroke-linecap: butt;
    stroke-miterlimit: 4;
    shape-rendering: auto;
  }

  .Line_6 {
    overflow: visible;
    position: absolute;
    width: 379px;
    height: 10px;
    left: 581.5px;
    top: 3326.5px;
    transform: matrix(1, 0, 0, 1, 0, 0);
  }

  #Line_7 {
    fill: transparent;
    stroke: rgba(54, 77, 137, 1);
    stroke-width: 10px;
    stroke-linejoin: miter;
    stroke-linecap: butt;
    stroke-miterlimit: 4;
    shape-rendering: auto;
  }

  .Line_7 {
    overflow: visible;
    position: absolute;
    width: 190px;
    height: 10px;
    left: 581.5px;
    top: 3352.5px;
    transform: matrix(1, 0, 0, 1, 0, 0);
  }

  #Line_8 {
    fill: transparent;
    stroke: rgba(54, 77, 137, 1);
    stroke-width: 10px;
    stroke-linejoin: miter;
    stroke-linecap: butt;
    stroke-miterlimit: 4;
    shape-rendering: auto;
  }

  .Line_8 {
    overflow: visible;
    position: absolute;
    width: 379px;
    height: 10px;
    left: 0px;
    top: 2899px;
    transform: matrix(1, 0, 0, 1, 0, 0);
  }

  #Line_9 {
    fill: transparent;
    stroke: rgba(54, 77, 137, 1);
    stroke-width: 10px;
    stroke-linejoin: miter;
    stroke-linecap: butt;
    stroke-miterlimit: 4;
    shape-rendering: auto;
  }

  .Line_9 {
    overflow: visible;
    position: absolute;
    width: 190px;
    height: 10px;
    left: 0px;
    top: 2925px;
    transform: matrix(1, 0, 0, 1, 0, 0);
  }

  #Ellipse_11 {
    fill: rgba(235, 242, 51, 1);
  }

  .Ellipse_11 {
    position: absolute;
    overflow: visible;
    width: 75px;
    height: 75px;
    left: -47px;
    top: 3258px;
  }

  #Ellipse_12 {
    fill: rgba(235, 242, 51, 0.341);
  }

  .Ellipse_12 {
    position: absolute;
    overflow: visible;
    width: 19px;
    height: 19px;
    left: 21px;
    top: 3206px;
  }

  #Ellipse_13 {
    fill: rgba(235, 242, 51, 0.639);
  }

  .Ellipse_13 {
    position: absolute;
    overflow: visible;
    width: 38px;
    height: 38px;
    left: 51px;
    top: 3273px;
  }

  #Ellipse_14 {
    fill: rgba(235, 242, 51, 0.89);
  }

  .Ellipse_14 {
    position: absolute;
    overflow: visible;
    width: 28px;
    height: 28px;
    left: 75px;
    top: 3216px;
  }

  #Ellipse_15 {
    fill: rgba(249, 255, 103, 1);
  }

  .Ellipse_15 {
    position: absolute;
    overflow: visible;
    width: 32px;
    height: 32px;
    left: 896px;
    top: 2921px;
  }

  #Ellipse_16 {
    fill: rgba(235, 242, 51, 0.341);
  }

  .Ellipse_16 {
    position: absolute;
    overflow: visible;
    width: 8px;
    height: 8px;
    left: 925px;
    top: 2899px;
  }

  #Ellipse_17 {
    fill: rgba(235, 242, 51, 0.639);
  }

  .Ellipse_17 {
    position: absolute;
    overflow: visible;
    width: 16px;
    height: 17px;
    left: 938px;
    top: 2927px;
  }

  #Ellipse_18 {
    fill: rgba(235, 242, 51, 0.89);
  }

  .Ellipse_18 {
    position: absolute;
    overflow: visible;
    width: 12px;
    height: 12px;
    left: 948px;
    top: 2903px;
  }

  #Group_131 {
    position: absolute;
    width: 1920px;
    height: 180px;
    left: 0px;
    top: 0px;
    overflow: visible;
  }

  #Rectangle_78 {
    fill: rgba(255, 255, 255, 1);
  }

  .Rectangle_78 {
    position: absolute;
    overflow: visible;
    width: 1920px;
    height: 180px;
    left: 0px;
    top: 0px;
  }

  #index_01_02_02_d {
    position: absolute;
    width: 453px;
    height: 95px;
    left: 58px;
    top: 71px;
    overflow: visible;
  }

  #Group_1 {
    position: absolute;
    width: 820px;
    height: 58px;
    left: 954px;
    top: 108px;
    overflow: visible;
  }

  #Component_1__5 {
    position: absolute;
    width: 160px;
    height: 58px;
    left: 440px;
    top: 0px;
    overflow: visible;
  }

  #_d {
    left: 0px;
    top: 0px;
    position: absolute;
    overflow: visible;
    width: 161px;
    white-space: nowrap;
    text-align: left;
    font-family: Source Han Sans HK;
    font-style: normal;
    font-weight: bold;
    font-size: 40px;
    color: rgba(93, 97, 105, 1);
  }

  #Component_1__4 {
    position: absolute;
    width: 160px;
    height: 58px;
    left: 660px;
    top: 0px;
    overflow: visible;
  }

  #_ea {
    left: 0px;
    top: 0px;
    position: absolute;
    overflow: visible;
    width: 161px;
    white-space: nowrap;
    text-align: left;
    font-family: Source Han Sans HK;
    font-style: normal;
    font-weight: bold;
    font-size: 40px;
    color: rgba(93, 97, 105, 1);
  }

  #Component_1__6 {
    position: absolute;
    width: 160px;
    height: 58px;
    left: 220px;
    top: 0px;
    overflow: visible;
  }

  #_eb {
    left: 0px;
    top: 0px;
    position: absolute;
    overflow: visible;
    width: 161px;
    white-space: nowrap;
    text-align: left;
    font-family: Source Han Sans HK;
    font-style: normal;
    font-weight: bold;
    font-size: 40px;
    color: rgba(93, 97, 105, 1);
  }

  #Component_1__32 {
    position: absolute;
    width: 160px;
    height: 58px;
    left: 0px;
    top: 0px;
    overflow: visible;
  }

  #_ec {
    left: 0px;
    top: 0px;
    position: absolute;
    overflow: visible;
    width: 161px;
    white-space: nowrap;
    text-align: left;
    font-family: Source Han Sans HK;
    font-style: normal;
    font-weight: bold;
    font-size: 40px;
    color: rgba(54, 77, 137, 1);
  }

  #ID18602266121579157322-128 {
    position: absolute;
    width: 88px;
    height: 88px;
    left: 1703px;
    top: 958px;
    overflow: visible;
  }
</style> -->
